<label class="input-label">{{ label }}</label>
<input type="text" class="mb-2 form-control" [formControl]="inputText" [maxlength]="maxLength">
